/*
  Exuberant Being — brand cart drawer wiring
  Connects the custom brand-header cart icon and the custom PDP buy form
  to Dawn's <cart-drawer> so the cart opens as a slide-out instead of
  navigating to /cart. Uses event delegation so no brand markup changes
  are required, and degrades gracefully to the /cart page if JS is off.
*/
(function () {
  function getDrawer() {
    return document.querySelector('cart-drawer');
  }

  function updateHeaderCount(count) {
    document.querySelectorAll('.brand-header__cart-count').forEach(function (el) {
      el.textContent = count;
    });
    document.querySelectorAll('.brand-header__cart').forEach(function (el) {
      el.setAttribute('aria-label', 'Cart, ' + count + ' items');
    });
  }

  // Open the drawer when the header cart link is clicked.
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('.brand-header__cart');
    if (!link) return;
    var drawer = getDrawer();
    if (!drawer) return; // no drawer on page -> let the /cart link work
    event.preventDefault();
    drawer.open(link);
  });

  // Keep the header count in sync when items are changed/removed in the drawer.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      var count = event && event.cartData && event.cartData.item_count;
      if (typeof count === 'number') updateHeaderCount(count);
    });
  }

  // AJAX add-to-cart for the custom PDP buy form, then open the drawer.
  document.addEventListener('submit', function (event) {
    var form = event.target.closest && event.target.closest('.bs-pdp__buy-form');
    if (!form) return;
    var drawer = getDrawer();
    if (!drawer) return; // no drawer -> default full-page submit to /cart

    event.preventDefault();
    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.setAttribute('aria-disabled', 'true');

    var fd = new FormData(form);
    var sections = drawer.getSectionsToRender
      ? drawer.getSectionsToRender().map(function (s) { return s.id; })
      : [];

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({
        items: [{ id: Number(fd.get('id')), quantity: parseInt(fd.get('quantity') || '1', 10) }],
        sections: sections,
        sections_url: window.location.pathname
      })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.status) {
          // Add failed (e.g. sold out) -> fall back to the cart page.
          window.location.href = window.routes.cart_url;
          return;
        }
        drawer.classList.remove('is-empty');
        if (drawer.renderContents) drawer.renderContents(data);
        return fetch(window.routes.cart_url + '.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) { updateHeaderCount(cart.item_count); })
          .catch(function () {});
      })
      .catch(function () {
        window.location.href = window.routes.cart_url;
      })
      .finally(function () {
        if (submitBtn) submitBtn.removeAttribute('aria-disabled');
      });
  });
})();
